import React, { ReactElement } from 'react';

export default function NotFoundComponent(): ReactElement {
  return <div>NotFoundComponent</div>;
}
